<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="咨询成果初审" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <!-- <a-button :loading="loading || saving" type="primary" @click="zjdfmxEdit">专家打分明细</a-button> -->
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="评审表编号">
                                            <a-input ref="cgysbbh" v-model="editData.cgysbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报表编号">
                                            <a-input ref="cgsbbbh" v-model="editData.cgsbbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报日期">
                                            <a-date-picker
                                                ref="sbrq"
                                                v-model="editData.sbrq"
                                                width="100%"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报年份">
                                            <FGDictSelectCN ref="sbnf" dictNo="P0002" v-model="editData.sbnf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报单位编号">
                                            <a-input ref="sbdwbh" v-model="editData.sbdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报单位名称">
                                            <a-input ref="sbdwmc" v-model="editData.sbdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item class="formlabelnewline" :label="'工程咨询单位  \n备案编号'">
                                            <a-input ref="babh" v-model="editData.babh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="地址">
                                            <a-input ref="xxdz" v-model="editData.xxdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="邮政编码">
                                            <a-input ref="yzbm" v-model="editData.yzbm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果名称">
                                            <a-input ref="xmmc" v-model="editData.xmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专业名称">
                                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果类型">
                                            <a-input ref="cglx" v-model="editData.cglx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报等级">
                                            <a-input ref="cgsbdj" v-model="editData.cgsbdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="项目密级">
                                            <a-input ref="xmmj" v-model="editData.xmmj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果开始时间">
                                            <a-input ref="cgkssj" v-model="editData.cgkssj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果完成时间">
                                            <a-input ref="cgwcsj" v-model="editData.cgwcsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="6">
                                        <a-form-item label="成果参与人员">
                                            <a-input ref="cgcyry" v-model="editData.cgcyry" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="委托单位">
                                            <a-input ref="wtdw" v-model="editData.wtdw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="是否涉密">
                                            <a-input ref="sfsm" v-model="editData.sfsm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="服务范围">
                                            <a-input ref="fwfw" v-model="editData.fwfw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="项目总投资(万元)">
                                            <a-input ref="xmztz" v-model="editData.xmztz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="规划级别">
                                            <a-input ref="ghjb" v-model="editData.ghjb" disabled />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="6">
                                        <a-form-item label="所属分组">
                                            <a-input ref="ssfz" v-model="editData.ssfz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="合规审核人员">
                                            <a-input ref="hgshry" v-model="editData.hgshry" disabled />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="6">
                                        <a-form-item label="审核结论">
                                            <a-input ref="shjl" v-model="editData.shjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入日期">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="评审专家">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专家类型">
                                            <a-input ref="zjlx" v-model="editData.zjlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专家单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="评审状态">
                                            <a-input ref="pszt" v-model="editData.pszt" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="初审结果">
                                            <FGDictSelectCN ref="csjg" dictNo="CG200101" v-model="editData.csjg" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="初审得分">
                                            <a-input-number ref="csdf" v-model="editData.csdf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                                            <a-button type="link" @click="openZjdfmxEdit">专家打分明细</a-button>
                                            <span style="color: red;">(点开此处录入分数明细后保存)</span>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <!-- <a-col :span="12">
                                        <a-form-item label="成果概况" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="cggk" v-model="editData.cggk" disabled :rows="3" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="成果应用情况" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="cgyyqk" v-model="editData.cgyyqk" disabled :rows="3" />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'其他主要  \n完成单位'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="qtzywcdw" v-model="editData.qtzywcdw" disabled :rows="1" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="初审意见" required :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea
                                                ref="csyj"
                                                :rows="5"
                                                v-model="editData.csyj"
                                                :maxLength="500"
                                                placeholder="请对照《申报成果打分参考表》对各类成果提出的评价目标填写初审意见，应明确是否推荐成果、推荐成果水平等次并说明理由。意见陈述要条理清晰、简明扼要、重点突出、推荐或不推荐的理由准确。字数为50-400字（请参考专家初评意见范例）!"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-popover title="初审意见范例" trigger="click" style="margin: -12vh 0 0 12vh;">
                                            <template #content>
                                                <p>可行性研究报告类初评意见参考</p>
                                                <p>
                                                    沪蓉国道主干线成都至南充高速公路全长214公里，设计速度80~120km/h，工程投资57.5亿元，属亚洲银行技术援助贷款项目。<br />
                                                    1、报告对国家及地区的经济政策研究到位，有一定前瞻性，符合国家西部开发和基础设施建设的方针。<br />
                                                    2、市场需求调查从西部地区经济特点出发，采用两种不同的方法进行沿线经济增长和交通量预测，预测结果，尤其是西部不发达地区的诱增交通量预测有独到之处，且经过几年的实践检验，比较真实，为控制本项目的建设规模和技术标准提供了科学依据。<br />
                                                    3、项目位于中低山丘陵区，地形地质条件复杂，“报告”在详细调查研究的基础上作了两大方案和八个局部方案的研究，推荐方案技术可行、经济合理。<br />
                                                    4、项目经济评价及风险分析程序先进，计算参数的选择符合西部地区的特殊经济状况，社会经济效益很高，而财务收益一般，结论实事求是，科学合理。亚行专家认为，可以作为我国西部地区工程建设可研报告的范本。<br />
                                                    5、项目所在地区自然地理环境脆弱，“报告”在工程方案研究中将环保作为重要因素之一，宁可用工程换取环保，贯彻了可持续发展的基本政策。
                                                </p>
                                                <p>规划报告类初评意见参考</p>
                                                <p>
                                                    1、该规划符合国家、省市政府提出的经济发展的有关政策，采用的方法和总体思路比较先进，规划目标明确。比较好的运用了系统工程的理论和方法，确定了整体控制、分项测算、综合平衡的技术路线。<br />
                                                    2、规划资料详实，包括了土地利用、种植业、林果业、食品加工、观光农业等17个方面的内容，充分体现了大型国有农场企业多行业、综合性、标准化的特点，论述清晰有据，具有较好的综合性和系统性，可操作性强。<br />
                                                    3、光明农场建设规划的8个方面委托单位已应用，农场是深圳农产品出口创汇基地，起到了示范作用。<br />
                                                    4、该规划把社会经济发展与环境保护有机结合起来，做到区域的可持续发展战略。<br />
                                                    5、规划投资合理，有较高的经济效益。<br />
                                                    6、该规划是农场经济发展和资源配置的决策依据。
                                                </p>
                                                <p>专题研究类初评意见参考</p>
                                                <p>
                                                    1、该项专题研究填补了我国交通系统工程风险分析的空白，在国内处于领先水平，在国际处于先进水平。研究成果被项目业主采用，同时在上海大小洋山港区工程中获得应用。<br />
                                                    2、研究成果直接影响到启动长江口深水航道治理二、三期工程的重大决策。<br />
                                                    3、从项目的建设、营运、市场进行全面的工程风险分析，在国内只有长江三峡工程一例，在国内外也不多见，因此，研究难度很大。<br />
                                                    4、该成果为风险管理、决策提供依据，故社会影响大。<br />
                                                    5、由于风险分析成果的量化，可操作性强。<br />
                                                    6、该成果在大型工程、重点工程、生命线工程建设中应用前景看好。<br />
                                                    7、该成果已通过中科院数学所、中国社科院8位专家的评估、鉴定，被评为20**年交通部优秀工程咨询成果一等奖。
                                                </p>
                                            </template>
                                            <a-button type="link">初审意见范例</a-button>
                                        </a-popover>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="内容提要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="nrty" v-model="editData.nrty" disabled :rows="10" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'成果特点及  \n申报理由'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="cgtdjsbly" :rows="10" v-model="editData.cgtdjsbly" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'审批(核准)  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="spyjzy" v-model="editData.spyjzy" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'评估(评审、审查)  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="pgyjzy" :rows="2" v-model="editData.pgyjzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'评价、鉴定  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="pjjdyjzy" v-model="editData.pjjdyjzy" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="其他摘要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="qtzy" :rows="2" v-model="editData.qtzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="申报单位意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="sbdwyj" v-model="editData.sbdwyj" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="bz" :rows="2" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 成果预审表评分明细表格 -->
                        <FGCollapsiblePanel title="成果初审表评分明细" v-if="false">
                            <vxe-table
                                ref="YSBMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataYSBMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="psnr" title="评审内容" min-width="150"></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="psjg"
                                    title="得分"
                                    width="100"
                                    ><template v-slot:edit="scope"> <a-input-number size="small" v-model="scope.row.psjg" :min="0" :precision="0"/></template>
                                </vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="psyj"
                                    title="评审意见"
                                    min-width="300"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.psyj" /> </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果资料明细表格 -->
                        <FGCollapsiblePanel title="成果资料明细">
                            <vxe-table
                                ref="ZLMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataZLMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                                <vxe-table-column field="zlmc" title="资料名称" width="300"></vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="100"></vxe-table-column>
                                <vxe-table-column title="附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="attachShow_zlmx(scope.row)">相关资料</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果获奖情况明细表格 -->
                        <FGCollapsiblePanel title="成果获奖情况明细">
                            <vxe-table
                                ref="HJQKMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataHJQKMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="hjsj" title="获奖时间" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="jlmc" title="奖励名称" width="300"></vxe-table-column>
                                <vxe-table-column field="jldj" title="等级" width="120" align="center"></vxe-table-column>
                                <vxe-table-column field="jjse" title="奖金数额(元)" width="110" header-align="center" align="right">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="sjbm" title="授奖部门" min-width="100"></vxe-table-column>
                                <vxe-table-column title="附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="attachShow_hjqk(scope.row)">相关材料</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果完成人情况明细表格 -->
                        <FGCollapsiblePanel title="成果主要完成人情况明细">
                            <vxe-table
                                ref="WCRMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataWCRMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="xm" title="姓名" width="120" align="center"></vxe-table-column>
                                <vxe-table-column field="xb" title="性别" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="nl" title="年龄" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="zc" title="职称" width="200"></vxe-table-column>
                                <vxe-table-column field="gzdw" title="工作单位" min-width="100"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload ref="attachdown" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
                <AttachModalDownload :attachCfg.sync="attachProps_zlmx" />
                <AttachModalDownload :attachCfg.sync="attachProps_hjqk" />
            </a-layout>
        </a-page-header>
        <ZjdfmxEdit :showEdit.sync="editProps.showEdit" :dataId="editProps.dataId" :zjdfblx="editProps.zjdfblx" @dataUpdated="loadData" />
    </div>
</template>

<script>
import ZjdfmxEdit from "./ZjdfmxEdit";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "DwxxwhEdit",
    components: { ZjdfmxEdit },
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            isShow1: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataYSBMX: [],
            editItemDataYSBMXLoading: false,
            editItemDataZLMX: [],
            editItemDataZLMXLoading: false,
            editItemDataHJQKMX: [],
            editItemDataHJQKMXLoading: false,
            editItemDataWCRMX: [],
            editItemDataWCRMXLoading: false,
            attachProps_zlmx: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_ZLMX",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            attachProps_hjqk: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            editProps: {
                showEdit: false,
                dataId: null,
                zjdfblx: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "编辑";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.lydjid,
                attachsource: "CG1001"
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.cgysbbh.focus();
        });
    },
    methods: {
        submit() {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxcggl/cgcsgl/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.csjg.focus();
                                //验证不通过，直接打开专家打分明细
                                this.openZjdfmxEdit();
                            }
                        });
                }
            });
        },
        onSave(btnType) {
            /*if (btnType === 1) {
                // 表单校验
                // if (!this.editData.csjg) {
                //     this.$FG_message.error("P0001", "初审结果").then(() => this.$refs.csjg.focus());
                //     return;
                // }
                if (!this.editData.csyj) {
                    this.$FG_message.error("P0001", "初审意见").then(() => this.$refs.csyj.focus());
                    return;
                }
            }*/
            if (!this.editData.csyj) {
                this.$FG_message.error("P0001", "初审意见").then(() => this.$refs.csyj.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/save",
                    {
                        data: this.editData,
                        YSBMXitemData: this.editItemDataYSBMX
                    },
                    {
                        showSuccess: btnType !== 0 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        } else {
                            this.loadData();
                        }
                    } else {
                        this.$refs.csjg.focus();
                    }
                });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载明细数据
                            this.loadItemDataYSBMX();
                            // 加载资料明细数据
                            this.loadItemDataZLMX();
                            // 加载获奖情况明细数据
                            this.loadItemDataHJQKMX();
                            // 加载完成人明细数据
                            this.loadItemDataWCRMX();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        loadItemDataYSBMX() {
            this.editItemDataYSBMX = [];
            this.editItemDataYSBMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/listItemYSBMX",
                    {
                        cgysbid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYSBMXLoading = false;
                    if (success) {
                        this.editItemDataYSBMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataZLMX() {
            this.editItemDataZLMX = [];
            this.editItemDataZLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemZlmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZLMXLoading = false;
                    if (success) {
                        this.editItemDataZLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataHJQKMX() {
            this.editItemDataHJQKMX = [];
            this.editItemDataHJQKMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataHJQKMXLoading = false;
                    if (success) {
                        this.editItemDataHJQKMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataWCRMX() {
            this.editItemDataWCRMX = [];
            this.editItemDataWCRMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemWcrqkmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataWCRMXLoading = false;
                    if (success) {
                        this.editItemDataWCRMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        // 附件管理
        attachShow_zlmx(row) {
            // 设置编辑记录id
            this.attachProps_zlmx.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_zlmx.visible = true;
        },
        // 附件管理
        attachShow_hjqk(row) {
            // 设置编辑记录id
            this.attachProps_hjqk.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_hjqk.visible = true;
        },
        //
        doOpenMessage() {
            this.$refs.notification.open({
                title: "初审意见参考",
                message:
                    "可行性研究报告类初评意见参考</br>沪蓉国道主干线成都至南充高速公路全长214公里，设计速度80~120km/h，工程投资57.5亿元，属亚洲银行技术援助贷款项目。",
                // 1、报告对国家及地区的经济政策研究到位，有一定前瞻性，符合国家西部开发和基础设施建设的方针。</br>2、市场需求调查从西部地区经济特点出发，采用两种不同的方法进行沿线经济增长和交通量预测，预测结果，尤其是西部不发达地区的诱增交通量预测有独到之处，且经过几年的实践检验，比较真实，为控制本项目的建设规模和技术标准提供了科学依据。</br>3、项目位于中低山丘陵区，地形地质条件复杂，“报告”在详细调查研究的基础上作了两大方案和八个局部方案的研究，推荐方案技术可行、经济合理。
                // 4、项目经济评价及风险分析程序先进，计算参数的选择符合西部地区的特殊经济状况，社会经济效益很高，而财务收益一般，结论实事求是，科学合理。亚行专家认为，可以作为我国西部地区工程建设可研报告的范本。
                // 5、项目所在地区自然地理环境脆弱，“报告”在工程方案研究中将环保作为重要因素之一，宁可用工程换取环保，贯彻了可持续发展的基本政策。
                // 规划报告类初评意见参考
                // 1、该规划符合国家、省市政府提出的经济发展的有关政策，采用的方法和总体思路比较先进，规划目标明确。比较好的运用了系统工程的理论和方法，确定了整体控制、分项测算、综合平衡的技术路线。
                // 2、规划资料详实，包括了土地利用、种植业、林果业、食品加工、观光农业等17个方面的内容，充分体现了大型国有农场企业多行业、综合性、标准化的特点，论述清晰有据，具有较好的综合性和系统性，可操作性强。
                // 3、光明农场建设规划的8个方面委托单位已应用，农场是深圳农产品出口创汇基地，起到了示范作用。
                // 4、该规划把社会经济发展与环境保护有机结合起来，做到区域的可持续发展战略。
                // 5、规划投资合理，有较高的经济效益。
                // 6、该规划是农场经济发展和资源配置的决策依据。
                // 专题研究类初评意见参考
                // 1、该项专题研究填补了我国交通系统工程风险分析的空白，在国内处于领先水平，在国际处于先进水平。研究成果被项目业主采用，同时在上海大小洋山港区工程中获得应用。
                // 2、研究成果直接影响到启动长江口深水航道治理二、三期工程的重大决策。
                // 3、从项目的建设、营运、市场进行全面的工程风险分析，在国内只有长江三峡工程一例，在国内外也不多见，因此，研究难度很大。
                // 4、该成果为风险管理、决策提供依据，故社会影响大。
                // 5、由于风险分析成果的量化，可操作性强/
                // 6、该成果在大型工程、重点工程、生命线工程建设中应用前景看好。
                // 7、该成果已通过中科院数学所、中国社科院8位专家的评估、鉴定，被评为20**年交通部优秀工程咨询成果一等奖。",
                duration: 0
            });
        },
        // 专家打分明细
        openZjdfmxEdit() {
            //保存主表数据
            this.onSave(2);
            // 设置编辑记录id
            this.editProps.dataId = this.editData.id;
            this.editProps.zjdfblx = this.editData.zjdfblx;
            // 显示编辑窗口
            this.editProps.showEdit = true;
        }
    }
};
</script>
<style lang="scss" scoped></style>
